const state = {
    collapsedCards: JSON.parse(localStorage.getItem("collapsedCards")) || {
      timeOverview: false,
      photosSection: false,
      paperSection: false,
      messagesSection: false,
    },
  };
  
  const mutations = {
    toggleCard(state, cardName) {
      state.collapsedCards[cardName] = !state.collapsedCards[cardName];
      localStorage.setItem("collapsedCards", JSON.stringify(state.collapsedCards));
    },
    setCollapsedState(state, newState) {
      state.collapsedCards = newState;
      localStorage.setItem("collapsedCards", JSON.stringify(state.collapsedCards));
    },
  };
  
  const actions = {
    toggleCard({ commit }, cardName) {
      commit("toggleCard", cardName);
    },
    loadCollapsedState({ commit }) {
      const savedState = JSON.parse(localStorage.getItem("collapsedCards"));
      if (savedState) {
        commit("setCollapsedState", savedState);
      }
    },
  };
  
  const getters = {
    isCardCollapsed: (state) => (cardName) => !!state.collapsedCards[cardName],
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
  